import { Button, Input, Modal, Row, Space } from "antd";
import { useState } from "react";
import dayjs from "dayjs";
import range from "helpers/range";
import useCreate from "hooks/useCreate";

import InputDate from "components/InputDate";
import TaskColorPicker from "components/TaskColorPicker";

const disabledDateTime = () => ({
  disabledMinutes: () => [
    ...range(1, 15),
    ...range(16, 30),
    ...range(31, 45),
    ...range(46, 60),
  ],
});

const NewTask = ({ handleConfirm, refetch, date: default_date, close }) => {
  const [content, setContent] = useState("");
  const [status_color, setStatusColor] = useState("red");
  const [date, setDate] = useState(default_date);

  const { is_saving, create } = useCreate({
    path: "/tasks",
    onSuccess: () => {
      close();
      refetch();
      handleConfirm();
    },
  });

  const handleSubmit = async () =>
    create({
      status_color,
      content,
      date,
    });

  return (
    <Modal
      id="day_modal"
      title="Dodaj priorytet do kalendarza"
      width={700}
      open
      footer={null}
      onCancel={close}
    >
      <Input.TextArea
        value={content}
        style={{ marginBottom: 30 }}
        onChange={({ target: { value } }) => setContent(value)}
        rows={7}
        maxLength={400}
        showCount={true}
      />
      <InputDate
        format="DD-MM-YYYY HH:mm"
        showTime={{ format: "HH:mm" }}
        disabledTime={disabledDateTime}
        defaultValue={dayjs(date)}
        onChange={(a) => setDate(a)}
        style={{ marginBottom: 20 }}
        disabled
        getPopupContainer={() => document.querySelector("#day_modal")}
      />
      <TaskColorPicker active_color={status_color} setColor={setStatusColor} />
      <Row justify="end">
        <Space>
          <Button onClick={close}>Anuluj</Button>
          <Button
            type="primary"
            htmlType="button"
            onClick={handleSubmit}
            disabled={!content || !date || is_saving}
            loading={is_saving}
          >
            Dodaj
          </Button>
        </Space>
      </Row>
    </Modal>
  );
};

export default NewTask;
